import React, { useEffect, useRef, useState } from "react";
import { Button, Divider, Form, Input, message, Modal } from "antd";
import './Login.css'
import { useNavigate } from "react-router-dom";
import { CloseCircleFilled, ExclamationCircleFilled } from "@ant-design/icons";
import type { SubmitCredentialsRequestModel } from "../models/SubmitCredentialsRequestModel";
import { submitCredentialsRequest } from "../service/LoginService";
import ModalContent from "../../../constant/ModalContent";
import Indicator from "../../common/components/Indicator";
import Header from "../../../components/header/Header";


export default function Login() {

    const [visible, setVisible] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [isLoading, setIsLoading] = useState(false)
    // const [logMessage, setLogMessage] = useState(LogContent.LOGIN_PAGE_MESSAGE);
    const searchParams = new URLSearchParams(window.location.search);
    const carrierPostData = window.location.search.match(/(?<=\?|&)carrierPostData=([^&]*)/)?.[1] ?? null;
    const sessionId = searchParams.get("sessionId") ?? null;
    const status = searchParams.get("status") ?? null;
    const mobileNumber = searchParams.get("msisdn") ?? null;
    const [form] = Form.useForm();
    // const isMountedRef = useRef(false);

    const navigate = useNavigate();

    const getUniqueId = () => {
        const min = 0;
        const max = 100;
        const rand = Math.floor(Math.random() * (max - min + 1) + min);
        console.log(rand);
        return rand;
    };

    const handleCancel = () => {
        setVisible(false);
        // setLogMessage(LogContent.LOGIN_PAGE_MESSAGE);
        // isMountedRef.current = false;
    };

    const handleCancelWithCallback = () => {
        // eslint-disable-next-line no-undef
        DataActivationController.doneSelected()
        setVisible(false);
        // setLogMessage(LogContent.LOGIN_PAGE_MESSAGE);
        // isMountedRef.current = false;
    };

    const handleSubmit = async (values) => {
        setIsLoading(true);
        try {
            const submitCredentialsRequestModel: SubmitCredentialsRequestModel = {
                "request-id": getUniqueId(),
                carrierPostData: carrierPostData,
                msisdn: values.mobileNumber,
                password: values.nicNumber,
                signUpFlag: status === "SIGNUP" ? true : false,
                transferFlag: false,
                channel: "ws"
            };
            console.log(submitCredentialsRequestModel);
            const response = await submitCredentialsRequest(submitCredentialsRequestModel);
            setIsLoading(false);
            console.log(response);
            if (response.resultCode === 6000) {
                localStorage.setItem("isLogin", true)
                console.log(localStorage.getItem("isLogin"));
                if (status === "SIGNUP") {
                    navigate("/proceed");
                } else if (status === "MANAGE_SUBSCRIPTION") {
                    navigate("/manage-subscription/device-list")
                }
            } else if (response.resultCode === 6400) {
                setModalContent(
                    <>
                        <CloseCircleFilled />
                        <h3>Invalid ID number</h3>
                        <div>
                            {ModalContent.INVALID_ID_NUMBER_MESSAGE}
                        </div>
                        <Divider />
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancel}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Invalid ID number").replace("{{page}}", LogContent.LOGIN_PAGE));
                // isMountedRef.current = false;
            } else if (response.resultCode === 6401) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled />
                        <h3>Not eligible for Apple Watch one number service</h3>
                        <div>
                            {ModalContent.NOT_ELIGIBLE_MESSAGE}
                        </div>
                        <Divider />
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Not eligible for Apple Watch one number service").replace("{{page}}", LogContent.LOGIN_PAGE));
                // isMountedRef.current = false;
            } else if (response.resultCode === 6402) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled />
                        <h3>Error Occurred!</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider />
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Error Occurred").replace("{{page}}", LogContent.LOGIN_PAGE));
                // isMountedRef.current = false;
            } else if (response.resultCode === 6403) {
                message.error(response.resultDesc, 1)
            } else if (response.resultCode === 6405) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled />
                        <h3>Maximum Device Count Reached</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider />
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Maximum Device Count Reached").replace("{{page}}", LogContent.LOGIN_PAGE));
                // isMountedRef.current = false;
            } else if (response.resultCode === 6406) {
                setModalContent(
                    <>
                        <ExclamationCircleFilled />
                        <h3>Your account is blocked.</h3>
                        <div>
                            {response.resultDesc}
                        </div>
                        <Divider />
                        <Button
                            type="text"
                            className="okButton"
                            onClick={handleCancelWithCallback}
                        >
                            OK
                        </Button>
                    </>
                )
                setVisible(true);
                // setLogMessage(LogContent.MODAL_CONTENT_MESSAGE.replace("{{heading}}", "Account blocked").replace("{{page}}", LogContent.LOGIN_PAGE));
                // isMountedRef.current = false;
            }

        } catch (error) {
            setIsLoading(false);
            message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
            throw new Error(error);
        }
    }


    useEffect(() => {

        localStorage.setItem("isLogin", false)
        console.log(localStorage.getItem('isLogin'));
        localStorage.setItem("carrierPostData", carrierPostData);
        localStorage.setItem("sessionId", sessionId);
        localStorage.setItem("status", status);
        localStorage.setItem("msisdn", mobileNumber)

        if (!carrierPostData || !sessionId || !status || !mobileNumber) {
            // Redirect to NotFoundPage if any data is null
            navigate('/not-found-page');
        }

        console.log(carrierPostData);
        console.log(sessionId);
        console.log(status);
        console.log(mobileNumber);

        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.LOGIN_PAGE,
        //         message: logMessage
        //     };
        //
        //     console.log("hello")
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }

    }, [carrierPostData, sessionId, status, mobileNumber])


    console.log(mobileNumber);
    return (
        <div >
            <div style={{ backgroundColor: "#E6E6E6", width: "100%" }}>
                <Header />
            </div>

            {isLoading && <Indicator />}

            <Form
                className="form"
                name="form"
                onFinish={handleSubmit}
            >
                <p className="para-title">
                    Activate and manage the wireless service on your Apple Watch
                </p>

                <Form.Item
                    name="mobileNumber"
                    initialValue={searchParams.get("msisdn")}
                // rules={[
                //     {
                //         required: true,
                //         logMessage: "Please enter the mobile number"
                //     },
                //     {
                //         pattern: /^(077|076|074)\d{7}$/,
                //         logMessage: "Enter the correct mobile number"
                //     }
                // ]}
                >
                    <Input
                        placeholder="Mobile number"
                        disabled={true}
                    // onFocus={handleInputFocus}
                    // value={mobileNumber}
                    />
                </Form.Item>
                <Form.Item
                    name="nicNumber"
                    rules={[
                        {
                            required: true,
                            message: "Please enter the NIC / Passport / Driving Licence Number"
                        },
                        {
                            pattern: /^(?:[A-Za-z0-9]{5,20}|[A-Z]{1,2}\d{6,9})$/, // Adjust this regex as needed for your passport format
                            message: "Enter a valid NIC or Passport Number"
                        }
                    ]}
                >
                    <Input
                        placeholder="NIC or Passport Number"
                    // value={nicNumber}
                    />
                </Form.Item>
                <Form.Item>
                    <Button
                        className="mainButton"
                        type="primary"
                        shape="round"
                        htmlType="submit"
                        style={{ backgroundColor: "#f13434" }}
                        disabled={isLoading}
                    >
                        LOGIN
                    </Button>
                </Form.Item>

            </Form>

            <Modal
                open={visible}
                onCancel={handleCancel}
                footer={null}
                closable={false}
            >
                {modalContent}
            </Modal>

        </div>
    )
}
